/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Range_FromInputs */

const cs_calendar_range_from = /** @type {(inputs: Calendar_Range_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od`)
};

const en_calendar_range_from = /** @type {(inputs: Calendar_Range_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Calendar_Range_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_range_from = /** @type {((inputs?: Calendar_Range_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Range_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_range_from(inputs)
	return cs_calendar_range_from(inputs)
});